module.exports = __webpack_public_path__ + "static/x5d-59b79749e71b5d8aaecb8d89b561169b.png";